import { Button, ButtonGroup, SxProps, useTheme } from "@mui/material";
import { SenecButtonProps } from "src/components/button/senec-button/SenecButton";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

export interface ButtonGroupProps {
    leftButton: SenecButtonProps;
    rightButton: SenecButtonProps;
    /**
     * Toggle whether left or right button is active
     */
    leftActive: boolean;
}

export const EkpButtonGroup = (props: ButtonGroupProps) => {
    const theme: SenecEkpTheme = useTheme();

    const groupedButtonStyling: SxProps = {
        width: { xsMobile: "100%" },
        borderRadius: 0,
        "&:hover": {
            background: theme.palette.senecSecondary.neutralGray000,
            color: theme.palette.senecPrimary.nightDarkGrey,
        },
    };

    return (
        <ButtonGroup
            variant="contained"
            color="primary"
            sx={{
                boxShadow: "none",
                width: { xsMobile: "100%", tablet: "auto" },
                borderRadius: "0.75rem",
                borderColor: theme.palette.senecSecondary.neutralGray20,
                borderStyle: "solid",
                borderWidth: "0.5px",
                overflow: "hidden",
                ".MuiButtonGroup-grouped:not(:last-of-type)": {
                    borderRight: `1px solid ${theme.palette.senecSecondary.neutralGray20}`,
                },
            }}
        >
            <Button
                onClick={props.leftButton.onClick}
                disableRipple
                color="inherit"
                sx={{
                    ...groupedButtonStyling,
                    background: props.leftActive ? theme.palette.senecPrimary.deepBlue : theme.palette.senecPrimary.white,
                    color: props.leftActive ? theme.palette.senecPrimary.white : theme.palette.senecPrimary.nightDarkGrey,
                }}
            >
                {props.leftButton.children}
            </Button>
            <Button
                onClick={props.rightButton.onClick}
                disableRipple
                color="inherit"
                sx={{
                    ...groupedButtonStyling,
                    background: props.leftActive ? theme.palette.senecPrimary.white : theme.palette.senecPrimary.deepBlue,
                    color: props.leftActive ? theme.palette.senecPrimary.nightDarkGrey : theme.palette.senecPrimary.white,
                }}
            >
                {props.rightButton.children}
            </Button>
        </ButtonGroup>
    );
};
